import { backButton } from '@telegram-apps/sdk-react'
import { useEffect } from 'react'
import { useNavigation } from '.'

export const useHandleBackButton = () => {
  const { history, goBack, currentPage } = useNavigation()

  useEffect(() => {
    if (!backButton.isSupported()) {
      return
    }
    if (!backButton.isMounted()) {
      backButton.mount()
    }

    if (history.length) {
      backButton.show()
      backButton.onClick(() => {
        // window.history.back()
        goBack()
      })
    } else {
      backButton.hide()
    }
  }, [history])

  useEffect(() => {
    if (currentPage.page === 'table' && backButton.isSupported()) {
      backButton.hide()
    }
  }, [currentPage.page])
}
